module.exports = __webpack_public_path__ + "assets/845c42102833e262570fffdfbf83f776.mp3";